import React, { Fragment } from 'react'
import './Notification.css'
import { Typography } from '@mui/material'
import { Launch } from '@mui/icons-material'
import { INotificationReducer } from '../interface'

interface INotificationProps {
  data: INotificationReducer
}

export default function Notification(props: INotificationProps) {
  const { data } = props

  return (
    <Fragment>
      <div
        className='notification'
        style={{
          backgroundSize: 'cover',
          marginTop: 0,
          backgroundColor: data.backgroundColor,
          cursor: data.url ? 'pointer' : 'default'
        }}
        onClick={() => {
          data.url && window.open(data.url)
        }}
      >
        <div className='booth-container'>
          <div className={data.url ? 'booth-text' : 'booth-no-button'}>
            <Typography variant='body1' style={{ color: data.textColor }}>
              {data.text}
            </Typography>
          </div>
          {data.url && <Launch style={{ color: data.textColor }} />}
        </div>
      </div>
    </Fragment>
  )
}
